'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect } from 'react';
import {
  compareAddedRowObjects,
  compareEditedRowObjects,
} from '../../shared/utils/commitHandlerHelper';
import GridTable from '../../shared/components/grid/GridTable';
import { useLanguageContextAPI } from '../../shared/context/LanguageContext';
import { t } from '../../i18next';
import { postRequest } from '../../shared/utils';

const UserRolesPage = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('user_roles');
  const { t } = useLanguageContextAPI();

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <UserRoles tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default UserRolesPage;

const UserRoles = ({ tableRes }) => {
  const { updateCustomConfig } = useColumnContextAPI();

  useEffect(() => {
    updateCustomConfig({
      AdditionalSortQuery: `(order_by: {role_name: asc})`,
      CommitHandler,
    });
  }, []);

  return <GridTable tableRes={tableRes} />;
};

const CommitHandler = async (props) => {
  const {
    addedRow,
    editedRow,
    deletedRow,
    tableDetails,
    editedRowOriginal,
    userDetails,
    configSchema,
  } = props;
  const { mbdDataGrid } = tableDetails;
  const timestamp = new Date().toISOString().substring(0, 19);

  const status = {
    success: true,
    errors: [],
  };

  const updateObjArr = editedRow.map((item) => {
    const where = {};
    where[mbdDataGrid.dataGridUniqueIdentifier] = {
      _eq: item[mbdDataGrid.dataGridUniqueIdentifier],
    };
    item.updated_by = userDetails.userId;
    item.update_date = timestamp;
    const setData = compareEditedRowObjects(
      item,
      editedRowOriginal,
      mbdDataGrid.dataGridUniqueIdentifier,
    );
    return {
      where,
      _set: setData,
    };
  });
  const mutationVariables = {};

  if (addedRow?.length) {
    addedRow.map((item) => (item.created_by = userDetails.userId));
    const data = compareAddedRowObjects(addedRow);
    mutationVariables['insert_objects'] = data;
  }

  if (deletedRow?.length) {
    mutationVariables['delete_id'] = deletedRow.map((i) => i?.id);
  }

  if (updateObjArr?.length) {
    mutationVariables['update_objects'] = updateObjArr;
  }

  try {
    const resp = await postRequest(`/api/userRoles`, {
      tableName: mbdDataGrid.dataGridSource,
      pkeyColumn: mbdDataGrid.dataGridUniqueIdentifier,
      objects: mutationVariables,
    });
    if (resp?.errors) {
      status.errors.push({
        message: t('error.action_failed_following', {
          msg: resp.errors[0].message,
        }),
      });
      status.success = false;
    }
    if (resp?.[`update_${configSchema}_mbd_roles_many`]) {
      status.success = true;
    }
  } catch {
    status.success = false;
    status.errors.push({
      message: t('exception_occurred'),
    });
  }
  return status;
};
